import React from 'react';
import basePath from 'utils/basePath';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import { isCordova } from 'utils/platform';

const AsyncSustainabilityPage = Load(() => import(/* webpackChunkName: "sustainability-page" */'./containers/SustainabilityContainer'));

const SustainabilityRoute = (
  <NavigationableLayout
    key={'sustainability-page'}
    path={`${basePath}/sustainability`}
    component={AsyncSustainabilityPage}
    showSearchInNavbar={false}
    noNavbar={isCordova()}
    showBottomNavigation
    transparentNavbar
  />
);

export default SustainabilityRoute;
